<template>
  <div class="comfort-filter">
    <UiCheckbox
      v-for="item in checkboxItems"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :checked="item.checked"
      class="comfort-filter__checkbox"
      @input="toggleValue(item.value)"
    >
      <template #hint>
        {{ item.description }}
      </template>
    </UiCheckbox>
  </div>
</template>

<script setup lang="ts">
  import { watch, ref, computed } from 'vue';
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { getComfortFilterItems } from './consts';
  import { type TComfortValue } from '@/features/filter/comfort';
  import { EExperienceFilterType } from '@/widgets/filtersBlock';
  import { useCategoryStore } from '@/shared/store';

  const { WILD, SIMPLE, STANDARD, PREMIUM } = getComfortFilterItems();

  const comfortItemsList = [WILD, SIMPLE, STANDARD, PREMIUM];

  const categoryStore = useCategoryStore();

  const checkedValues = ref(
    new Set<TComfortValue>(categoryStore.tmpFilters[EExperienceFilterType.COMFORT_TYPE].comfort_type),
  );

  const toggleValue = (value: TComfortValue) => {
    if (checkedValues.value.has(value)) {
      checkedValues.value.delete(value);
    } else {
      checkedValues.value.add(value);
    }

    categoryStore.setComfortType(Array.from(checkedValues.value));
  };

  const checkboxItems = computed(() =>
    comfortItemsList.map((item) => ({
      ...item,
      checked: checkedValues.value.has(item.value),
    })),
  );

  watch(
    () => categoryStore.tmpFilters[EExperienceFilterType.COMFORT_TYPE].comfort_type,
    () => {
      checkedValues.value = new Set<TComfortValue>(
        categoryStore.tmpFilters[EExperienceFilterType.COMFORT_TYPE].comfort_type,
      );
    },
  );
</script>

<style scoped lang="scss">
  .comfort-filter {
    margin-top: 8px;
  }

  .comfort-filter__checkbox {
    grid-template-columns: 20px 1fr;
    width: 100%;
    margin: 8px 0;
  }
</style>
